'use client';

import { c as _c } from "react/compiler-runtime";
import { Checkbox, Field, FieldError, FieldLabel } from '@repo/ui/components';
import { Fragment, ReactNode, useId } from 'react';
import { ReadOnlyTooltip, useReadOnly } from '../components/readonly.tsx';
import { dedupeErrors } from '../lib/dedupe-errors.ts';
import { useFieldContext } from '../lib/form-context.ts';
interface FormCheckboxListProps<TItem> {
  disabled?: boolean;
  getLabel: (item: TItem) => ReactNode;
  getValue: (item: TItem) => string;
  isPending?: boolean;
  items: TItem[];
  label?: ReactNode | string;
}
export const FormCheckboxList = t0 => {
  const $ = _c(61);
  const {
    disabled: t1,
    getLabel,
    getValue,
    isPending: t2,
    items,
    label
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const isPending = t2 === undefined ? false : t2;
  const field = useFieldContext();
  let t3;
  if ($[0] !== field.state.meta.errors) {
    t3 = field.state.meta.errors ?? [];
    $[0] = field.state.meta.errors;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t3) {
    t4 = dedupeErrors(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const errors = t4;
  const groupId = useId();
  let t5;
  if ($[4] !== field.state.value) {
    t5 = field.state.value ?? [];
    $[4] = field.state.value;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const selected = t5;
  const isReadOnly = useReadOnly();
  let t6;
  if ($[6] !== field || $[7] !== selected) {
    t6 = (value, checked) => {
      field.handleChange(checked ? [...selected, value] : selected.filter(current => current !== value));
    };
    $[6] = field;
    $[7] = selected;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleToggle = t6;
  if (isReadOnly) {
    let T0;
    let T1;
    let t7;
    let t8;
    let t9;
    if ($[9] !== getLabel || $[10] !== getValue || $[11] !== items || $[12] !== label || $[13] !== selected) {
      let t10;
      if ($[19] !== getValue || $[20] !== selected) {
        t10 = item => selected.includes(getValue(item));
        $[19] = getValue;
        $[20] = selected;
        $[21] = t10;
      } else {
        t10 = $[21];
      }
      const selectedItems = items.filter(t10);
      T1 = Field;
      t8 = "gap-2";
      if ($[22] !== label) {
        t9 = label && <FieldLabel className="text-base">{label}</FieldLabel>;
        $[22] = label;
        $[23] = t9;
      } else {
        t9 = $[23];
      }
      T0 = ReadOnlyTooltip;
      t7 = selectedItems.length > 0 ? selectedItems.map((item_0, index) => <Fragment key={getValue(item_0)}>{index > 0 && ", "}{getLabel(item_0)}</Fragment>) : "-";
      $[9] = getLabel;
      $[10] = getValue;
      $[11] = items;
      $[12] = label;
      $[13] = selected;
      $[14] = T0;
      $[15] = T1;
      $[16] = t7;
      $[17] = t8;
      $[18] = t9;
    } else {
      T0 = $[14];
      T1 = $[15];
      t7 = $[16];
      t8 = $[17];
      t9 = $[18];
    }
    let t10;
    if ($[24] !== T0 || $[25] !== t7) {
      t10 = <T0>{t7}</T0>;
      $[24] = T0;
      $[25] = t7;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    let t11;
    if ($[27] !== T1 || $[28] !== t10 || $[29] !== t8 || $[30] !== t9) {
      t11 = <T1 className={t8}>{t9}{t10}</T1>;
      $[27] = T1;
      $[28] = t10;
      $[29] = t8;
      $[30] = t9;
      $[31] = t11;
    } else {
      t11 = $[31];
    }
    return t11;
  }
  let t7;
  if ($[32] !== groupId || $[33] !== label) {
    t7 = label && <FieldLabel className="text-base" htmlFor={groupId}>{label}</FieldLabel>;
    $[32] = groupId;
    $[33] = label;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  let t8;
  if ($[35] !== disabled || $[36] !== getLabel || $[37] !== getValue || $[38] !== groupId || $[39] !== handleToggle || $[40] !== isPending || $[41] !== items || $[42] !== selected) {
    let t9;
    if ($[44] !== disabled || $[45] !== getLabel || $[46] !== getValue || $[47] !== groupId || $[48] !== handleToggle || $[49] !== isPending || $[50] !== selected) {
      t9 = item_1 => {
        const value_0 = getValue(item_1);
        const itemId = `${groupId}-${value_0}`;
        return <div className="flex items-center gap-2" key={value_0}><Checkbox checked={selected.includes(value_0)} disabled={isPending || disabled} id={itemId} onCheckedChange={checked_0 => handleToggle(value_0, checked_0 === true)} /><FieldLabel className="text-base font-normal" htmlFor={itemId}>{getLabel(item_1)}</FieldLabel></div>;
      };
      $[44] = disabled;
      $[45] = getLabel;
      $[46] = getValue;
      $[47] = groupId;
      $[48] = handleToggle;
      $[49] = isPending;
      $[50] = selected;
      $[51] = t9;
    } else {
      t9 = $[51];
    }
    t8 = items.map(t9);
    $[35] = disabled;
    $[36] = getLabel;
    $[37] = getValue;
    $[38] = groupId;
    $[39] = handleToggle;
    $[40] = isPending;
    $[41] = items;
    $[42] = selected;
    $[43] = t8;
  } else {
    t8 = $[43];
  }
  let t9;
  if ($[52] !== groupId || $[53] !== t8) {
    t9 = <div className="flex flex-col gap-2" id={groupId}>{t8}</div>;
    $[52] = groupId;
    $[53] = t8;
    $[54] = t9;
  } else {
    t9 = $[54];
  }
  let t10;
  if ($[55] !== errors) {
    t10 = <FieldError className="text-sm" errors={errors} data-sentry-element="FieldError" data-sentry-source-file="form-checkbox-list.tsx" />;
    $[55] = errors;
    $[56] = t10;
  } else {
    t10 = $[56];
  }
  let t11;
  if ($[57] !== t10 || $[58] !== t7 || $[59] !== t9) {
    t11 = <Field className="gap-2" data-sentry-element="Field" data-sentry-component="FormCheckboxList" data-sentry-source-file="form-checkbox-list.tsx">{t7}{t9}{t10}</Field>;
    $[57] = t10;
    $[58] = t7;
    $[59] = t9;
    $[60] = t11;
  } else {
    t11 = $[60];
  }
  return t11;
};